module.exports = __webpack_public_path__ + "img/landing-invest-ideas.349ffeef.svg";